import React from "react";
import { Grid, Typography, CircularProgress } from "@material-ui/core";
import moment from "moment-timezone";
import clsx from "clsx";
import { useStyles } from "../../pages/LicensePlateSearchPage/LicensePlateSearchPage.styles";

const LicensePlateDetails = ({ licensePlate, ticketId, startTime, imageData, isImageLoading }) => {
    const classes = useStyles();
    
    const formatDt = (dt) => {
        return moment(dt).format("llll");
    };

    return (
        <>
            <Grid>
                <div
                    data-value-full={licensePlate}
                    data-value={licensePlate}
                    className={clsx(classes.label, classes.flexCenter, "license-plate")}
                >
                    License Plate:
                    <span className={clsx(classes.paddingLeft, classes.ticketId)}>{licensePlate}</span>
                </div>
            </Grid>
            <Grid
                container
                data-id="LicensePlateInfo"
                className={clsx(classes.spacing, "license-plate-dates")}
                data-entry-date={formatDt(startTime)}
            >
                <Grid item xs={4} className={clsx(classes.label)}>
                    Entry Date
                </Grid>
                <Grid item xs={8} className={clsx(classes.textEnd, classes.value)}>
                    {formatDt(startTime)}
                </Grid>
                <Grid item xs={12} className={clsx(classes.imageWrapper, "lpr-image")}>
                    {isImageLoading === true ? (
                        <CircularProgress size={40} />
                    ) : (
                        <>
                            {imageData ? (
                                <img src={imageData}
                                    className={clsx(["image", classes.image])}
                                    alt={`${ticketId} LPR Image`}
                                    title={`LPR Image`}
                                />
                            ) : (
                                <Typography align="center">Image not available</Typography>
                            )}
                        </>
                    )}

                </Grid>
            </Grid>
        </>
    );
};

export default LicensePlateDetails;
